import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardMerchantListResponse,
} from '../types';
import {
  DASHBOARD_MERCHANTS_QUERY_KEY,
  DASHBOARD_MERCHANTS_URL,
  DASHBOARD_PERMISSIONS,
} from '../constants';

export default function useDashboardMerchantsQuery(): IContextQueryResult<IDashboardMerchantListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardMerchantListResponse, Error>({
    queryKey: [DASHBOARD_MERCHANTS_QUERY_KEY],
    staleTime: Infinity,
    queryFn: ({ signal }) => fetchGet(DASHBOARD_MERCHANTS_URL, {
      signal,
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_GET_STATS,
    }),
  });
}
